<div class="progress-bar" [class.error]="progress > progressTarget">
    <div [style.width.%]="progress > progressTarget ? (progressTarget / progress) * 100 : (progress / progressTarget) * 100" class="timeline-fill-success"></div>
</div>
